<groundworks-modal [title]="title">
  <groundworks-modal-body>
    @if (selectableContacts().length > 0) {
      <label class="form-label" for="statement-recipient">Statement Recipient <span class="text-danger">*</span></label>
      <ng-select
        inputId="statement-recipient"
        [items]="selectableContacts()"
        bindValue="id"
        bindLabel="name"
        [ngModel]="selectedContactId()"
        (ngModelChange)="selectedContactId.set($event)"
        placeholder="Select a Contact to receive the statement"
      />
    } @else {
      <p class="text-muted mb-0">
        No eligible recipients for this opportunity. A contact needs a phone number and must not be marked do-not-text.
      </p>
    }
    @if (hasBillingError()) {
      <div class="alert alert-danger mt-3 mb-0" role="alert" data-testid="billing-error">
        There was a problem gathering payment details. Please close and try again.
      </div>
    } @else {
      <div class="mt-3">
        <groundworks-term-value [items]="totalsItems()" />
      </div>
      <div class="form-check mt-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="split-payment"
          data-testid="split-payment"
          [disabled]="!canSplit()"
          [checked]="splitPayment()"
          (change)="splitPayment.set($any($event.target).checked)"
        />
        <label class="form-check-label" for="split-payment">Split Payment</label>
        @if (!canSplit()) {
          <div class="form-text">Nothing is due today, so there is no balance to split.</div>
        }
      </div>
      @if (splitPayment() && canSplit()) {
        <div class="mt-2">
          <label class="form-label" for="split-amount">Amount <span class="text-danger">*</span></label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="split-amount"
              data-testid="split-amount"
              type="text"
              inputmode="decimal"
              class="form-control text-end"
              placeholder="0.00"
              [ngModel]="splitAmountInput()"
              (ngModelChange)="splitAmountInput.set($event)"
              (blur)="onSplitAmountBlur()"
            />
          </div>
          @if (splitAmountError()) {
            <div class="text-danger small mt-1" data-testid="split-amount-error">{{ splitAmountError() }}</div>
          }
        </div>
      }
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
